import { BcFieldProps } from "../../../interface/props/bcfield";
import { BCInputCont, BCTextArea } from "../../../styled/global.styled";

const TextAreaField = ({ field, register, isRequired, errors }: BcFieldProps) => (
    <BCInputCont className="bc-form-field">
        <BCTextArea
            className="bc-input-area"
            placeholder={field.placeholder}
            aria-label={field.label}
            id={field.item}
            {...register(field.item, { required: isRequired })}
        ></BCTextArea>
        <label htmlFor={field.item}>{field.label}</label>
        {errors && <span>Help Text</span>}
    </BCInputCont>
);
 
export default TextAreaField